import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import Navbar from './Navbar';

const EcosistemaIncentivoPage: React.FC = () => {
    const { language } = useLanguage();

    const t = (es: string, en: string) => language === 'es' ? es : en;

    const handleThemeChange = (theme: number) => {
        const bookRoutes = {
            2: '/libros/1',
            3: '/libros/2', 
            4: '/libros/3',
            5: '/libros/4',
            6: '/libros/5',
            7: '/libros/6',
            8: '/libros/7',
            9: '/libros/8'
        };
        const route = bookRoutes[theme as keyof typeof bookRoutes];
        if (route) {
            window.location.href = route;
        }
    };

    const ecosistemaSections = [
        {
            id: 'ecosistema',
            title: t('Ecosistema de incentivo', 'Incentive Ecosystem'),
            image: '/images/infosection/ecosistemainsentivos.png',
            color: 'from-orange-500 to-red-600',
            description: t(
                'Sistema integral de incentivos que motiva y recompensa el aprendizaje y desarrollo continuo.',
                'Comprehensive incentive system that motivates and rewards continuous learning and development.'
            ),
            benefits: [
                { title: t('Incentivos', 'Incentives'), desc: t('Motivación integral', 'Comprehensive motivation') },
                { title: t('Recompensas', 'Rewards'), desc: t('Sistema de beneficios', 'Benefit system') },
                { title: t('Desarrollo', 'Development'), desc: t('Crecimiento continuo', 'Continuous growth') }
            ]
        },
        {
            id: 'compensacion',
            title: t('Sistema de compesación y referidos', 'Compensation and Referral System'),
            image: '/images/infosection/sistemacompensaciondiferidos.png',
            color: 'from-yellow-500 to-amber-600',
            description: t(
                'Recibe periódicamente una compesación monetaria por referidos antigüedad.',
                'Receive periodic monetary compensation for referrals and seniority.'
            ),
            benefits: [
                { title: t('Compensación', 'Compensation'), desc: t('Pagos periódicos', 'Periodic payments') },
                { title: t('Referidos', 'Referrals'), desc: t('Sistema de recomendaciones', 'Recommendation system') },
                { title: t('Antigüedad', 'Seniority'), desc: t('Reconocimiento por tiempo', 'Time recognition') }
            ]
        },
        {
            id: 'financiamiento',
            title: t('Financiamiento de proyectos', 'Project Financing'),
            image: '/images/infosection/financiamientoproyectos.png',
            color: 'from-indigo-500 to-blue-600',
            description: t(
                'Supera las metas y desarrolla tu negocio; nosotros colocamos la financiación.',
                'Exceed goals and develop your business; we provide the financing.'
            ),
            benefits: [
                { title: t('Metas', 'Goals'), desc: t('Superar objetivos', 'Exceed objectives') },
                { title: t('Negocio', 'Business'), desc: t('Desarrollo empresarial', 'Business development') },
                { title: t('Financiación', 'Financing'), desc: t('Apoyo económico', 'Economic support') }
            ]
        }
    ];

    return (
        <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-indigo-50">
            {/* Navbar */}
            <Navbar currentTheme={1} onThemeChange={handleThemeChange} />
            
            {/* Contenido principal */}
            <main className="pt-16">
                {/* Secciones del ecosistema de incentivo */}
                {ecosistemaSections.map((section, index) => (
                    <section key={section.id} className="min-h-screen relative">
                        {/* Imagen de fondo */}
                        <div className="absolute inset-0 w-full h-full">
                            <img 
                                src={section.image}
                                alt={section.title}
                                className="w-full h-full object-cover object-center"
                            />
                        </div>
                        
                        {/* Contenido centrado */}
                        <div className="relative z-10 flex items-center justify-center min-h-screen">
                            <div className={`max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center ${section.id === 'ecosistema' ? 'self-start pt-16' : ''} ${section.id === 'compensacion' ? 'self-start pt-15 transform translate-x-60' : ''} ${section.id === 'financiamiento' ? 'self-start pt-15 transform -translate-x-60' : ''}`}>
                                <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-8">
                                    {section.title}
                                </h2>
                                
                                {/* Mostrar cuadro solo si no es ecosistema */}
                                {section.id !== 'ecosistema' && (
                                    <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-8 sm:p-12 shadow-2xl">
                                        <p className="text-xl sm:text-2xl text-gray-800 leading-relaxed">
                                            {section.description}
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </section>
                ))}
            </main>
        </div>
    );
};

export default EcosistemaIncentivoPage; 